
import _ from 'lodash';
// import { message } from 'antd';
import store from '../store';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { NotificationManager} from 'react-notifications';

export default function apiHeaders() {
	const state = store.getState();
	return {headers: state.user.headers, ...{ withCredentials: true }};
}

export function getTrophyText(status) {
    if(status === 'b') {
        return 'Bronze'
    } else if(status === 's') {
        return 'Silver'
    } else if(status === 'g') {
        return 'Gold'
    } else if(status === 'p') {
        return 'Platinum'
    }
    return status;
}

export function getStatusText(status) {
    if(status === 'a') {
        return 'Active'
    } else if(status === 'p') {
        return 'Pending'
    } else if(status === 'd') {
        return 'Drafting'
    } else if(status === 'arc') {
        return 'Archived'
    }
    return status;
}

export const trainingModuleTypes = [
    {label: 'Drinking', value: 'dri'},
    {label: 'Smoking', value: 'smo'},
	{label: 'Diet', value: 'die'},
	{label: 'Mental', value: 'men'},
	{label: 'Breathing', value: 'bre'},
	{label: 'Havening', value: 'hav'},
	{label: 'PreSurgery', value: 'pre'},
    {label: 'Strength', value: 'str'},
    {label: 'Endurance', value: 'end'},
    {label: 'Sleep', value: 'sle'},
    {label: 'Balance', value: 'bal'},
    {label: 'Dance', value: 'dan'},
    {label: 'Nutrition', value: 'nut'},
    {label: 'Cognitive', value: 'cog'},
    {label: 'Generic', value: 'gen'},
    {label: 'Information', value: 'inf'},
]	
export function getTrainingModuleTypeText(value) {
    var title = ""
    trainingModuleTypes.map((t) => {
        if(t.value === value) {
            title = t.label
        }
    })
    return title;
}


export const userTypes = [
    {label: 'Admin', value: 'admin'},
    {label: 'Patient', value: 'patient'},
]	
export function getUserTypeText(value) {
    var title = ""
    userTypes.map((t) => {
        if(t.value === value) {
            title = t.label
        }
    })
    return title;
}

export const genderTypes = [
    {label: 'Male', value: 'm'},
    {label: 'Female', value: 'f'},
]	
export function getGenderTypeText(value) {
    var title = ""
    genderTypes.map((t) => {
        if(t.value === value) {
            title = t.label
        }
    })
    return title;
}


export const questionnaireTypes = [
    {label: 'General', value: 'g'},
    // {label: 'Compact', value: 'c'},
    {label: 'Mood Analysis', value: 'm'},
    {label: 'Surgery Complete Check', value: 'scc'},
    {label: 'Training Optout Check', value: 'toc'},
    {label: 'Training Optout Feedback', value: 'tof'},
	{label: 'User onboarding', value: 'o'},
]
export function getQuestionnaireTypeText(value) {
    var title = ""
    questionnaireTypes.map((t) => {
        if(t.value === value) {
            title = t.label
        }
    })
    return title;
}	


export const questionOptions = [
    {value:"o", label:"Single Option Input", otherProps: {config: {decimalPlaces: 2, mean: 0}, right_alignment: false, check_box: false}},
    {value:"m", label:"Multiple Option Input", otherProps: {config: {decimalPlaces: 2, mean: 0}}},
    {value:"t", label:"Text Input", otherProps: {config: {decimalPlaces: 2, mean: 0}}},
    {value:"f", label:"Decimal Input", otherProps: {config: {decimalPlaces: 2, mean: 0}}},
    // {value:"r", label:"Slider Input", otherProps: {config: {rangeInput: true, rangeFrom: 0, rangeTo: 100, stepInterval: 1, decimalPlaces: 2, mean: 0}}},
    // {value:"smiley", label:"Slider Smiley", otherProps: {config: {rangeInput: true, rangeFrom: 0, rangeTo: 100, stepInterval: 1, decimalPlaces: 2, mean: 0}}},
    // {value:"c", label:"Combo box", otherProps: {config: {decimalPlaces: 2, mean: 0}}},
    {value:"date", label:"Date Input", otherProps: {config: {decimalPlaces: 2, mean: 0}}},
    {value:"file", label:"File Input", otherProps: {config: {decimalPlaces: 2, mean: 0}}},
    // {value:"diagnostic", label:"Diagnostic Items", otherProps: {config: {decimalPlaces: 2, mean: 0}}}
]
export function questionOptionText(value) {
    var title = ""
    questionOptions.map((t) => {
        if(t.value === value) {
            title = t.label
        }
    })
    return title;
}	



export function getObjectTrans(obj, key, language) {
    let Trans;
    if (!_.isArray(obj.translations)) {
        Trans = obj.translations;
    }
    Trans = _.find(obj.translations, o => o.language === language);
    const translated = Trans && key in Trans && Trans[key] ? Trans[key] : obj[key];
    // if (decode) {
    //     return entities.decode(translated);
    // }
    return translated;
}

// message.config({
// 	maxCount: 1,
// });

export function showSuccess(msg){
    // message.success(msg, 3);
    NotificationManager.info(msg);
}

export function showInfo(msg){
    // message.info(msg, 3);
    NotificationManager.success(msg);
}

export function showError(msg){
    // message.error(msg, 3);
    NotificationManager.error(msg);
}

export function getTimeString(dr){
    const hrs = ~~(dr / 3600);
    const mins = ~~((dr % 3600) / 60);
    const secs = ~~dr % 60;
    var timeString = ""
    if(hrs) {
        timeString = hrs + ' Hours  '
    }
    if(mins) {
        timeString = timeString + mins +  ' Minutes  '
    }
    if(secs) {
        timeString = timeString + secs +  ' Seconds  '
    }
    return timeString
}

export const exerciseTypes = [
    {label: 'Upper Body', value: 'u'},
    {label: 'Core Body', value: 'c'},
	{label: 'Lower Body', value: 'l'},
]	
export function getExerciseTypeText(value) {
    var title = ""
    exerciseTypes.map((t) => {
        if(t.value === value) {
            title = t.label
        }
    })
    return title;
}
export const progressionChoices = [
    {label: 'Week 1', value: 'w1'},
    {label: 'Week 2', value: 'w2'},
	{label: 'Week 3', value: 'w3'},
]	
export function getProgressionChoiceText(value) {
    var title = ""
    progressionChoices.map((t) => {
        if(t.value === value) {
            title = t.label
        }
    })
    return title;
}

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
	'& .MuiDialogContent-root': {
		padding: theme.spacing(2),
	},
	'& .MuiDialogActions-root': {
		padding: theme.spacing(1),
	},
}));
export const BootstrapDialogTitle = (props) => {
	const { children, onClose, ...other } = props;
	return (
		<DialogTitle sx={{ m: 0, p: 2 }} {...other}>
			{children}
			{onClose ? (
				<IconButton
					aria-label="close"
					onClick={onClose}
					sx={{
						position: 'absolute',
						right: 8,
						top: 8,
						color: (theme) => theme.palette.grey[500],
					}}
				>
					<CloseIcon />
				</IconButton>
			) : null}
		</DialogTitle>
	);
};

export const GraphColors = ['#A2ADB9', '#509097', '#32AC8C', '#F8B695', '#FDDF8E', '#FBDCD2', '#99C8C4', '#8B96A2', '#7EC8C9', '#5DD5AB','#F19879', '#FCD171', '#FACCC3', '#D2E9E5', '#CBD1D7', '#AFEAE7'];